module.exports = __webpack_public_path__ + "img/content.18271066.png";